import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// router setup
import routes from './routes/routes'

import Dialog from 'vue-dialog-loading'

// plugin setup
Vue.use(VueRouter)
Vue.use(LightBootstrap)
Vue.use(Dialog, {
    dialogBtnColor: '#0f0'
})

// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'nav-item active',
    mode: 'history'
})

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) {
        return context.next;
    }

    return (...parameters) => {
        context.next(...parameters);

        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({...context, next: nextMiddleware});
    };
}

router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware)
            ? to.meta.middleware
            : [to.meta.middleware];

        const context = {
            from,
            next,
            router,
            to,
        };

        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({...context, next: nextMiddleware});
    }

    return next();
});

Vue.prototype.$hostname = process.env.BASE_URL;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
})



// WEBPACK FOOTER //
// ./src/main.js